import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const ArrowLeft: React.FC<IIconProps> = ({
  size = IconSizes.md,
  color = 'black',
  UNSAFE_className: _UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5721 7.28476C20.9518 7.66443 20.9518 8.28001 20.5721 8.65969L13.4818 15.75L20.5721 22.8403C20.9518 23.22 20.9518 23.8356 20.5721 24.2152C20.1924 24.5949 19.5769 24.5949 19.1972 24.2152L11.4194 16.4375C11.2371 16.2551 11.1346 16.0078 11.1346 15.75C11.1346 15.4922 11.2371 15.2449 11.4194 15.0625L19.1972 7.28476C19.5769 6.90508 20.1924 6.90508 20.5721 7.28476Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowLeft;
